var MANIFEST_STYLES = {
  utility: {
    hashed: 'utility.44565de77bd1b780bc916781116c8f81.min.css',
    versioned: 'utility.min.css'
  },
  core: {
    hashed: 'core.2e7ffaea1ddc976f9ba13683e4923c4a.min.css',
    versioned: 'core.min.css'
  },
  zoomControls: {
    hashed: 'zoom-controls.9c87f956af940730852c6639a6b5641b.min.css',
    versioned: 'zoom-controls.min.css'
  },
  visible: {
    hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
    versioned: 'visible.min.css'
  },
  toggleSwitch: {
    hashed: 'toggle-switch.b324430baf9c1672a31592f7f21b60a8.min.css',
    versioned: 'toggle-switch.min.css'
  },
  thumbnailsHero: {
    hashed: 'thumbnails-hero.127bf76d624f281af5a1142c6f9fd3b3.min.css',
    versioned: 'thumbnails-hero.min.css'
  },
  tabs: {
    hashed: 'tabs.93332294f86722dabbf62d12b56f2272.min.css',
    versioned: 'tabs.min.css'
  },
  table: {
    hashed: 'table.51f0cd0d507d810c3e8bfbdd33e88247.min.css',
    versioned: 'table.min.css'
  },
  stepIndicator: {
    hashed: 'step-indicator.064d7ddef64c12504b214b4b2ae41baa.min.css',
    versioned: 'step-indicator.min.css'
  },
  standardTile: {
    hashed: 'standard-tile.a85a9cdc61d548110d604a061b10a0a4.min.css',
    versioned: 'standard-tile.min.css'
  },
  standardHero: {
    hashed: 'standard-hero.b3c1a491ec7d82c4d1de9c62525d9e27.min.css',
    versioned: 'standard-hero.min.css'
  },
  standardBanner: {
    hashed: 'standard-banner.76bc30b36139633dd673a261ac2d9d3e.min.css',
    versioned: 'standard-banner.min.css'
  },
  spinner: {
    hashed: 'spinner.9a990a85357eca2f1f8806cdb2a05e7f.min.css',
    versioned: 'spinner.min.css'
  },
  selectionSet: {
    hashed: 'selection-set.7d985c1ef3840fbd2286d8017fafed41.min.css',
    versioned: 'selection-set.min.css'
  },
  secondaryTile: {
    hashed: 'secondary-tile.c06e97649b2664c9b1240a8f9641dd4d.min.css',
    versioned: 'secondary-tile.min.css'
  },
  ratingsStars: {
    hashed: 'ratings-stars.765b21f1d1b20b188f366da8ceabc1c4.min.css',
    versioned: 'ratings-stars.min.css'
  },
  promoBar: {
    hashed: 'promo-bar.a4229c4e42c9cbf2cf292444f86e4ddf.min.css',
    versioned: 'promo-bar.min.css'
  },
  progressiveImage: {
    hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
    versioned: 'progressive-image.min.css'
  },
  progressBar: {
    hashed: 'progress-bar.43a70e3abf66fcfe184e39306f6d3797.min.css',
    versioned: 'progress-bar.min.css'
  },
  pricing: {
    hashed: 'pricing.5bd74032196cd8df893b87a8016f7fb3.min.css',
    versioned: 'pricing.min.css'
  },
  priceBar: {
    hashed: 'price-bar.eae520979569aa6127b370a3992029d6.min.css',
    versioned: 'price-bar.min.css'
  },
  popover: {
    hashed: 'popover.a67d40a617e7633b76fd2d8216b3da2f.min.css',
    versioned: 'popover.min.css'
  },
  pagination: {
    hashed: 'pagination.82d7f842de68d2575de76785111c897c.min.css',
    versioned: 'pagination.min.css'
  },
  modalDialog: {
    hashed: 'modal-dialog.0b0d006293f7d467a230cf3540b758d2.min.css',
    versioned: 'modal-dialog.min.css'
  },
  listbox: {
    hashed: 'listbox.cdda589a561e15af83edfd0f729afd72.min.css',
    versioned: 'listbox.min.css'
  },
  legacyPopover: {
    hashed: 'legacy-popover.2072b7445c4c8618a7f2e07cf4a0866b.min.css',
    versioned: 'legacy-popover.min.css'
  },
  legacyModalDialog: {
    hashed: 'legacy-modal-dialog.ca8a31d4374e5f45a517e774583c7de9.min.css',
    versioned: 'legacy-modal-dialog.min.css'
  },
  legacyListbox: {
    hashed: 'legacy-listbox.7336f8e8cd1b8fa4a8db343b910e47ce.min.css',
    versioned: 'legacy-listbox.min.css'
  },
  legacyCombobox: {
    hashed: 'legacy-combobox.cb1789f3ca06194258114a6c8d0d0b19.min.css',
    versioned: 'legacy-combobox.min.css'
  },
  icon: {
    hashed: 'icon.de0c3f374d63ed3869be4238010afb64.min.css',
    versioned: 'icon.min.css'
  },
  hidden: {
    hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
    versioned: 'hidden.min.css'
  },
  grid: {
    hashed: 'grid.90f7a5f4a2da2ebf5a5d0c1dbf88c062.min.css',
    versioned: 'grid.min.css'
  },
  fieldSet: {
    hashed: 'field-set.b4b1adfeffa5420eb5d5f1e46900d413.min.css',
    versioned: 'field-set.min.css'
  },
  embeddedTextHero: {
    hashed: 'embedded-text-hero.c16a5e17e2487ffc4a4c616e7111d6c9.min.css',
    versioned: 'embedded-text-hero.min.css'
  },
  detailsBanner: {
    hashed: 'details-banner.4ae73a272f89095f48bf5cd8aec94acf.min.css',
    versioned: 'details-banner.min.css'
  },
  controlIcon: {
    hashed: 'control-icon.1be7da330ecf24ecf63997a73b5d299b.min.css',
    versioned: 'control-icon.min.css'
  },
  combobox: {
    hashed: 'combobox.6ed8b931ac7e89e55e420f2d8a10b783.min.css',
    versioned: 'combobox.min.css'
  },
  carousel: {
    hashed: 'carousel.9c96b746761e0beaff061e5b06118e90.min.css',
    versioned: 'carousel.min.css'
  },
  button: {
    hashed: 'button.256c390367b32a6c385af87fbd60b859.min.css',
    versioned: 'button.min.css'
  },
  banner: {
    hashed: 'banner.dd7968116430f1db38a320b01c1ad639.min.css',
    versioned: 'banner.min.css'
  },
  anchorBar: {
    hashed: 'anchor-bar.b92a9f256e18ae085aa369b0e451a4e4.min.css',
    versioned: 'anchor-bar.min.css'
  },
  alertBox: {
    hashed: 'alert-box.8675c2b3a3d3d6d9882f79deba355ed0.min.css',
    versioned: 'alert-box.min.css'
  },
  accordion: {
    hashed: 'accordion.284a13988fa5cc37e86fa4b066d7439d.min.css',
    versioned: 'accordion.min.css'
  }
};
export { MANIFEST_STYLES };